import _ from "lodash"

export const JPEG = "image/jpeg";
export const PDF = ["application/pdf"]
export const IMAGES = [JPEG, "image/png", "image/webp"]
export const VIDEO = ["video/mp4", "video/webm"]
export const AUDIO = ["audio/mpeg", "audio/ogg"]
export const XLS = [
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-excel",
    "text/csv"
]
export const ICS = ["text/calendar"]

export const FILE_IMAGE = 1
export const FILE_VIDEO = 2
export const FILE_PDF = 3

export const mimeImage = () => {
    return IMAGES
}

export const mimeVideo = () => {
    return VIDEO
}

export const mimePdf = () => {
    return PDF
}

export const mimeXls = () => {
    return XLS
}

export const mimeImageVideo = () => {
    return _.concat(IMAGES, VIDEO)
}

export const mimeICS = () => {
    return ICS
}

export const certificateBackgroundMime = () => {
    return [JPEG]
}

export const ticketBackgroundMime = () => {
    return [JPEG]
}